module.exports = __webpack_public_path__ + "img/home_icon_color.f22afbb5.svg";